import {
  base64StringJsonFormat,
  objectJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";

interface CustomerContactData {
  email?: string;
  phone?: string;
}

const _contactDataFormat = objectJsonFormat<CustomerContactData>(
  {},
  { email: stringJsonFormat, phone: stringJsonFormat },
);
export const contactDataFormat = base64StringJsonFormat(_contactDataFormat);
